import { useApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import { discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';
import { StorageQueue } from '../hooks';

export const useStorageQueue = ({
  namespace,
  name,
}: {
  namespace: string;
  name: string;
}) => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef) ?? { fetch };

  const clearQueue = async (queue: StorageQueue): Promise<void> => {
    const baseUrlData = await discoveryApi.getBaseUrl('storage-account');

    const urlData = `${baseUrlData}/${namespace}/${name}/queue/${queue.name}/clear`;

    const responseData = await fetchApi.fetch(urlData);
    if (!responseData.ok) {
      throw await ResponseError.fromResponse(responseData);
    }
  };

  return { clearQueue };
};
